import { FormGroup } from '@angular/forms';

export class FormChecker {
  public static checkForm(form: FormGroup) {
    for (const i in form.controls) {
      const controls = form.controls[i] as FormGroup;

      if (form.controls.hasOwnProperty(i)) {
        controls.markAsTouched();
        controls.markAsDirty();
        controls.updateValueAndValidity();

        // For nested groups
        for (const j in controls?.controls) {
          controls.controls[j].markAsDirty();
        }
      }
    }
  }
}
